<template>
    <div
      class="section-settings"
      >
      <TIcon
        class="cursor-pointer"
        name="gear"
        @click.native.prevent.stop="show_settings = !show_settings"
        />
        <div
        v-if="show_settings"
        class="section-settings-popup"
        v-click-outside="closePopUp"
        >
        <div class="d-flex">
            <RadialCheckbox 
                foreground_color="white"
                :is_checked="show_clip_caps"
                @setActive="$emit('changeShowClipCaps', !show_clip_caps)" 
            />
            <TText value="Show Clip Caps"/>
        </div>
        <div class="d-flex" v-if="show_clip_caps">
            <RadialCheckbox 
                foreground_color="white"
                :is_checked="flip_normals"
                @setActive="$emit('changeFlipNormals', !flip_normals)" 
            />
            <TText value="Flip Normals"/>
        </div>
        </div>
    </div>
  </template>
  <script>
    import TIcon from '@/components/Taktify/TIcon.component.vue';
    import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';

    export default {
      props: ['show_clip_caps', 'flip_normals'],
      components: {
        TIcon,
        RadialCheckbox,
      },
      data: () => ({
        show_settings: false,
      }),
      methods: {
        closePopUp() {
            this.show_settings = false;
        }
      }
    }
  </script>
  <style>
    .section-settings {
        display: flex;
        /* flex-direction: column; */
        align-items: center;
        justify-content: center;
    }
    .section-settings-popup {
        /* position: absolute; */
        padding: 3px;
        background-color: grey;
        border: 1px solid white;
        border-radius: 5px;
    }
  </style>
  